// noinspection DuplicatedCode

import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API
export const getCountStatusJobRequest = createAsyncThunk(
    "getCountStatusJobRequest/get",
    async (thunkAPI) => {
        let formData = new FormData();

        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+'getCountStatusJobRequest',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const KirimActivityClient = createAsyncThunk(
    "KirimActivityClient/kirimJobRequest",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"kirimActivityClient",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const getJRApprovalByUser = createAsyncThunk(
    "getJRApprovalByUser/kirimJobRequest",
    async (thunkAPI) => {
        let formData = new FormData();
        // formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJRApprovalByUser",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const kirimJobRequest = createAsyncThunk(
    "jobRequestTransaksi/kirimJobRequest",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"kirimJobRequest",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestDetailActivity = createAsyncThunk(
    "getJobRequestDetailActivity/getDetail",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetailUserActivity",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const getJobRequestTransaksi = createAsyncThunk(
    "jobRequestTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequest",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestAllTransaksi = createAsyncThunk(
    "getJobRequestAllTransaksi/getAl",
    async ({start, count, search, filter, filter2}, thunkAPI) => {
        let formData = new FormData();
        if (!filter) {
            filter = ""
        }
        if (!filter2) {
            filter2 = ""
        }
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        formData.append("filter", filter);
        formData.append("filter2", filter2);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestReport = createAsyncThunk(
    "getJobRequestReport/getAl",
    async ({start, count, search, filter, filter2, StartDate, EndDate, KlienID}, thunkAPI) => {
        let formData = new FormData();
        if (!filter) {
        }
        if (!filter2) {
        }
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        formData.append("filter", 200);
        formData.append("filter2", 200);
        formData.append("StartDate", StartDate);
        formData.append("EndDate", EndDate);
        formData.append("KlienID", KlienID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestReport",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
export const getGeneratedReports = createAsyncThunk(
    "getGeneratedReports/getAl",
    async ({start, count, search, filter, filter2, StartDate, EndDate, KlienID}, thunkAPI) => {
        let formData = new FormData();
        if (!filter) {
        }
        if (!filter2) {
        }
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        formData.append("filter", 200);
        formData.append("filter2", 200);
        formData.append("StartDate", StartDate);
        formData.append("EndDate", EndDate);
        formData.append("KlienID", KlienID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getGeneratedReports",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
export const generateReport = createAsyncThunk(
    "generateReports/getAl",
    async (param, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"generateReports",
                param,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const getJobRequestDetailOperasional = createAsyncThunk(
    "jobRequestTransaksi/getDetail",
    async ({QuatationNo}, thunkAPI) => {
        let formData = new FormData();
        formData.append("QuatationNo", QuatationNo);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetail",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertJobRequestTransaksi = createAsyncThunk(
    "jobRequestTransaksi/insert",
    async (
        {
            QuatationNo,
            SPKNo,
            Priority,
            Tanggal,
            PortServiceVessel,
            PortServiceStevedoring,
            PortServiceCargodoring,
            PortServiceDelivery,
            PortServiceReceiving,
            PortServiceStacking,
            PortServiceBulk,
            Rental,
            AreaRental,
            ManPowerService,
            WasteService,
            GeneralService,
        },
        thunkAPI
    ) => {
        let formData = new FormData();
        formData.append("QuatationNo", QuatationNo);
        formData.append("SPKNo", SPKNo);
        formData.append("Priority", Priority);
        formData.append("Date", Tanggal);
        formData.append("PortServiceVessel", PortServiceVessel);
        formData.append("PortServiceStevedoring", PortServiceStevedoring);
        formData.append("PortServiceCargodoring", PortServiceCargodoring);
        formData.append("PortServiceDelivery", PortServiceDelivery);
        formData.append("PortServiceReceiving", PortServiceReceiving);
        formData.append("PortServiceStacking", PortServiceStacking);
        formData.append("PortServiceBulk", PortServiceBulk);
        formData.append("Rental", Rental);
        formData.append("AreaRental", AreaRental);
        formData.append("ManPowerService", ManPowerService);
        formData.append("WasteService", WasteService);
        formData.append("GeneralService", GeneralService);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertJobRequest",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateJobRequestTransaksi = createAsyncThunk(
    "jobRequestTransaksi/update",
    async (
        data,
        thunkAPI
    ) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateJobRequest",
                data,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

//INIT
const initialState = {
    message: "",
    KirimJobRequestData: [],
    isKirimJobRequestFetching: false,
    isKirimJobRequestSuccess: false,
    isKirimJobRequestError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isGetAllFetching: false,
    isGetAllSuccess: false,
    isGetAllError: false,
    isGetDetailFetching: false,
    isGetDetailSuccess: false,
    isGetDetailError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    approvallist: [],
    homeData: {},
    approvalClient: false,
};

//SLICES
export const jobRequestTransaksiSlice = createSlice({
    name: "pengobatanTransaksi",
    initialState,
    reducers: {},
    extraReducers: {

        [KirimActivityClient.rejected]: (state, {payload}) => {
            state.isKirimJobRequestFetching = false;
        },
        [KirimActivityClient.pending]: (state) => {
            state.isInsertSuccess = false
            state.isKirimJobRequestFetching = false;
        },

        [KirimActivityClient.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.isInsertSuccess = false
            state.approvalClient = true
            return state;
        },

        [getJRApprovalByUser.rejected]: (state, {payload}) => {
            state.isKirimJobRequestFetching = false;
        },
        [getJRApprovalByUser.pending]: (state) => {
            state.isInsertSuccess = false
            state.isKirimJobRequestFetching = false;
        },
        [getJobRequestDetailActivity.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailSuccess = true;
            state.message = payload.message;
            state.dataDetail = payload.data;
            state.isUpdateActivitySuccess = false;
            return state;
        },
        [getJobRequestDetailActivity.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateActivitySuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestDetailActivity.pending]: (state) => {
            state.isGetDetailFetching = true;
            state.isUpdateActivitySuccess = false;

        },

        [getJRApprovalByUser.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.isInsertSuccess = false
            state.approvalClient = false

            state.approvallist = payload.data;
            return state;
        },

        // GET
        [kirimJobRequest.fulfilled]: (state, {payload}) => {
            state.kirimJobRequestData = payload.data[0];
            state.isKirimJobRequestSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [kirimJobRequest.rejected]: (state, {payload}) => {
            state.isKirimJobRequestFetching = false;
        },
        [kirimJobRequest.pending]: (state) => {
            state.isKirimJobRequestFetching = false;
        },

        [getJobRequestTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.isInsertSuccess = false;
            state.isUpdateSuccess = false;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJobRequestTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isUpdateSuccess = false;

            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getJobRequestTransaksi.pending]: (state) => {
            state.isUpdateSuccess = false;
            state.isGetFetching = true;
        },

        [getJobRequestAllTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllSuccess = true;
            state.isGetDetailSuccess = false;
            state.isUpdateSuccess = false;
            state.data = [];
            state.dataDetail = [];
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJobRequestAllTransaksi.rejected]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestAllTransaksi.pending]: (state) => {
            state.isUpdateSuccess = false;
            state.isGetAllFetching = true;
        },

        [getJobRequestReport.fulfilled]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllSuccess = true;
            state.isGetDetailSuccess = false;
            state.isUpdateSuccess = false;
            state.data = [];
            state.dataDetail = [];
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJobRequestReport.rejected]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestReport.pending]: (state) => {
            state.isUpdateSuccess = false;
            state.isGetAllFetching = true;
        },

        [getGeneratedReports.fulfilled]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllSuccess = true;
            state.isGetDetailSuccess = false;
            state.isUpdateSuccess = false;
            state.data = [];
            state.dataDetail = [];
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getGeneratedReports.rejected]: (state, {payload}) => {
            state.isGetAllFetching = false;
            state.isGetAllError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getGeneratedReports.pending]: (state) => {
            state.isUpdateSuccess = false;
            state.isGetAllFetching = true;
        },


        [getJobRequestDetailOperasional.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailSuccess = true;
            state.isUpdateSuccess = false;

            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJobRequestDetailOperasional.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestDetailOperasional.pending]: (state) => {
            state.isUpdateSuccess = false;

            state.isGetDetailFetching = true;
        },

        //getCountStatusJobRequest

        [getCountStatusJobRequest.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.homeData = payload.data;
            return state;
        },
        [getCountStatusJobRequest.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCountStatusJobRequest.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertJobRequestTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertJobRequestTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertJobRequestTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateJobRequestTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateJobRequestTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateJobRequestTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },


        [generateReport.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [generateReport.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [generateReport.pending]: (state) => {
            state.isInsertFetching = true;
        },
    },
});

export const jobRequestTransaksiSelector = (state) => state.jobRequestTransaksi;

export const kirimResetPassword = createAsyncThunk(
    "jobRequestTransaksi/kirimResetPassword",
    async ({Username}, thunkAPI) => {
        let formData = new FormData();
        formData.append("userName", Username);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"resetPassword",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
